function keys(object) {
    return Object.keys(object);
}
export { keys };
